import React from 'react'
import { Link } from 'react-router-dom'
import Layout from '~layout'
import * as Styled from './FAQPage.styles'
// eslint-disable-next-line import/extensions
import * as StyledText from '~styles/Textual.styles'
import searchAndFilter from '~assets/faq/search-and-filter.png'
import login from '~assets/faq/login.png'
import googleGithub from '~assets/faq/google-github.png'
import finalSteps from '~assets/faq/final-steps.png'
import Paths from '~routes/paths'

import searchAndFilterWebp from '~assets/faq/search-and-filter.webp'
import loginWebp from '~assets/faq/login.webp'
import googleGithubWebp from '~assets/faq/google-github.webp'
import finalStepsWebp from '~assets/faq/final-steps.webp'

const FAQPage: React.FC = () => {
  let counter = 0

  return (
    <Layout>
      <Layout.Content isCompact>
        <StyledText.RowContainer>
          <StyledText.Navigation>
            <StyledText.Link href="#what-is-unbounded-network">What is the Unbounded Network?</StyledText.Link>
            <StyledText.Link href="#what-are-bound-tokens">What are the BOUND tokens?</StyledText.Link>
            <StyledText.Link href="#how-to-connect">Now do I connect to the Unbounded Network?</StyledText.Link>
            <StyledText.Link href="#how-to-bridge">How do I transfer my BOUND tokens into the Unbounded Network?</StyledText.Link>
            <StyledText.Link href="#why-register">Unbounded Network: Why Register?</StyledText.Link>
            <StyledText.Link href="#for-whom">Who can benefit from the Unbounded Network?</StyledText.Link>
            <StyledText.Link href="#what-can-be-searched">What can I search for on Unbounded Network?</StyledText.Link>
            <StyledText.Link href="#filter-unbounded">How to search and filter?</StyledText.Link>
            {/* <StyledText.Link href="#create-new-network">How do I create an Unbounded Network account?</StyledText.Link>
            <StyledText.Link href="#reset-password">How do I reset a forgotten password?</StyledText.Link> */}
          </StyledText.Navigation>
          <StyledText.Text>
            <StyledText.Title>Frequently asked questions</StyledText.Title>
            <StyledText.Header id="what-is-unbounded-network">{++counter}. What is the Unbounded Network?</StyledText.Header>
            <StyledText.Paragraph>
              Using Unbounded Network&apos;s open ecosystem, individuals and organizations can access blockchain-powered, ready-to-use web3
              applications and platforms, trusted, actionable, decentralized data and models, and inspiring content.
            </StyledText.Paragraph>
            <StyledText.Header id="what-are-bound-tokens">{++counter}. What are the BOUND tokens?</StyledText.Header>
            <StyledText.Paragraph>
              BOUND tokens are a crucial part of the Unbounded Network ecosystem. They can be freely exchanged on Ethereum and used for payments in
              dApps deployed within our ecosystem, as well as paying for the network fees while transacting on the Unbounded Network.
            </StyledText.Paragraph>
            <StyledText.Paragraph>
              Note that in order to use your BOUND tokens for the Unbounded-enabled apps, you will first need to connect to the Unbounded Network and
              transfer your tokens from the Ethereum blockchain.
            </StyledText.Paragraph>
            <StyledText.Header id="how-to-connect">{++counter}. Now do I connect to the Unbounded Network?</StyledText.Header>
            <StyledText.Paragraph>
              Note that the Unbounded Network is currently running a closed beta on a devnet. A public beta launch is already scheduled and will be
              announced separately.
            </StyledText.Paragraph>
            <StyledText.Paragraph>
              Unbounded Network is an Ethereum-compatible blockchain, so you can use your MetaMask wallet in order to connect. To do this, you will
              need to open the network selection menu in MetaMask, create a custom network, and configure the following settings:
              <Styled.Quote>
                <span>
                  <strong>Suggested network name</strong>: Unbounded Network Devnet (L2)
                  <br />
                </span>
                <span>
                  <strong>Default RPC URL</strong>:{' '}
                  <a href="https://dev-net.unbounded.network:3050" target="_blank" rel="noreferrer">
                    https://dev-net.unbounded.network:3050
                  </a>
                  <br />
                </span>
                <span>
                  <strong>Chain ID</strong>: 270
                  <br />
                </span>
                <span>
                  <strong>Currency symbol</strong>: BOUND
                </span>
              </Styled.Quote>
              Additionally, specifically for the devnet, you will need to set up the Layer-1 blockchain connection (as another custom network):
              <Styled.Quote>
                <span>
                  <strong>Suggested network name</strong>: Unbounded Network Devnet (L1)
                  <br />
                </span>
                <span>
                  <strong>Default RPC URL</strong>:{' '}
                  <a href="https://dev-net.unbounded.network:15045" target="_blank" rel="noreferrer">
                    https://dev-net.unbounded.network:15045
                  </a>
                  <br />
                </span>
                <span>
                  <strong>Chain ID</strong>: 9<br />
                </span>
                <span>
                  <strong>Currency symbol</strong>: ETH
                </span>
              </Styled.Quote>
            </StyledText.Paragraph>
            <StyledText.Header id="how-to-bridge">{++counter}. How do I transfer my BOUND tokens into the Unbounded Network?</StyledText.Header>
            <StyledText.Paragraph>It&apos;s simple!</StyledText.Paragraph>
            <StyledText.Paragraph>
              You just need to connect to the Unbounded Network (described above), and then use the{' '}
              <Link to={Paths.tokens}>token management page</Link> to transfer a specified amount of BOUND tokens that you own on Ethereum to be used
              within the Unbounded Network.
            </StyledText.Paragraph>
            <StyledText.Paragraph>
              Note that during the beta phase it is not possible to transfer your BOUND tokens back from the Unbounded Network to Ethereum, so this
              action is irreversible.
            </StyledText.Paragraph>
            <StyledText.Header id="how-to-get-bounds">{++counter}. How do I receive BOUNDs?</StyledText.Header>
            <StyledText.Paragraph>
              If you have vesting rewards available to you, you can claim them in the <Link to={Paths.tokens}>token management page</Link>. The tokens
              will be awarded on the Ethereum blockchain.
            </StyledText.Paragraph>
            <StyledText.Header id="why-register">{++counter}. Unbounded Network: Why Register?</StyledText.Header>
            <StyledText.Paragraph>
              <StyledText.List>
                <StyledText.ListElement>
                  Track, discover, and analyze web3 and blockchain projects, dApps, companies, and organizations{' '}
                </StyledText.ListElement>
                <StyledText.ListElement>Access multiple blockchains and dApps with your Unbounded ID</StyledText.ListElement>
                <StyledText.ListElement>Claim and register your FREE company or dApp profile and gain exposure</StyledText.ListElement>
                <StyledText.ListElement>Get market insights and inspiring content</StyledText.ListElement>
              </StyledText.List>
            </StyledText.Paragraph>
            <StyledText.Header id="for-whom">{++counter}. Who can benefit from the Unbounded Network?</StyledText.Header>
            <StyledText.Paragraph>
              Anyone looking to accelerate blockchain and web3 adoption or take their blockchain &quot;affairs&quot; to the next level. <br /> <br />
              Unbounded Network is ideal for investors, financial institutions, analysts, research teams, modelers, data makers, and data consumers,
              web3 and blockchain developers, blockchain/web3 &quot;signal to noise&quot; maximalists, and more.
              <br />
              <br />
              They can:
              <StyledText.List>
                <StyledText.ListElement>
                  Discover, track and analyze the latest networks, dApps, blockchains, and defi projects
                </StyledText.ListElement>
                <StyledText.ListElement>Easily discover and “consume” decentralized data and models</StyledText.ListElement>
                <StyledText.ListElement>Control their wealth and get live feeds and alerts our powerful web3 wallet</StyledText.ListElement>
                <StyledText.ListElement>
                  Utilize our scalable Unbounded Network product stack to build, share, and monetize web3 data, models, analytics/indices, and other
                  digital goods or services
                </StyledText.ListElement>
              </StyledText.List>
            </StyledText.Paragraph>
            <StyledText.Header id="what-can-be-searched">{++counter}. What can I search for on Unbounded Network?</StyledText.Header>
            <StyledText.Paragraph>
              You can search for networks, applications, vendors, people, transaction data, contracts and more on The Unbounded Network. Start
              searching with keywords (for example: Real Estate) and you&apos;ll see a list of results you can filter. To get some ideas, you can use
              our networks filter and discover networks to join.
            </StyledText.Paragraph>
            <StyledText.Header id="filter-unbounded">{++counter}. How to search and filter?</StyledText.Header>
            <StyledText.Paragraph>
              Unbounded allows you to filter your search results to find what you&apos;re looking for. <br />
              <br />
              Using any of these filtering options will refine your search:
              <StyledText.List>
                <StyledText.ListElement>Type something into the search bar at the top-left search bar.</StyledText.ListElement>
                <StyledText.ListElement>
                  Check one or more filter boxes on the left side of the window to further narrow down your search results.
                </StyledText.ListElement>
              </StyledText.List>
              <StyledText.Image lazy={true} webpSrc={searchAndFilterWebp} pngSrc={searchAndFilter} alt="Search and filter" />
            </StyledText.Paragraph>
            <StyledText.Header id="create-new-network">{++counter}. How do I create an Unbounded Network account?</StyledText.Header>
            <StyledText.Paragraph>
              You can register with a username and password, or by using a wallet or with a social login (such as Google or GitHub).
              <br />
              To register using a username and password
              <StyledText.List>
                <StyledText.ListElement>
                  Go to{' '}
                  <StyledText.InlineLink target="_blank" href="https://id.unbounded.network/" rel="noopener noreferrer">
                    https://id.unbounded.network/
                  </StyledText.InlineLink>
                </StyledText.ListElement>
                <StyledText.ListElement>Enter your Username, email, and password</StyledText.ListElement>
                <StyledText.ListElement>Click the &quot;Agree & Create Account&quot; button</StyledText.ListElement>
                <StyledText.ListElement>To finish creating your account, you need to confirm your email.</StyledText.ListElement>
              </StyledText.List>
              <StyledText.Image lazy={true} webpSrc={loginWebp} pngSrc={login} alt="Login" />
            </StyledText.Paragraph>
            {/* <StyledText.Paragraph>
              You can register with a Google or a Github account by following these steps: <br />
              <StyledText.List>
                <StyledText.ListElement>In the form, click on the Google or GitHub icon (see image).</StyledText.ListElement>
                <StyledText.ListElement>Follow the instructions to choose an account</StyledText.ListElement>
                <StyledText.ListElement>Register (see image) by completing the final steps.</StyledText.ListElement>
                <StyledText.ListElement>Then click &quot;Agree & Create Account&quot;</StyledText.ListElement>
                <StyledText.ListElement>To finish creating your account, you need to confirm your email.</StyledText.ListElement>
              </StyledText.List>
              <StyledText.Image lazy={true} webpSrc={googleGithubWebp} pngSrc={googleGithub} alt="Social register" />
              <StyledText.Image lazy={true} webpSrc={finalStepsWebp} pngSrc={finalSteps} alt="Social register final steps" />
            </StyledText.Paragraph> */}
            <StyledText.Paragraph>
              You can register with a Google account by following these steps: <br />
              <StyledText.List>
                <StyledText.ListElement>In the form, click on the Google icon (see image).</StyledText.ListElement>
                <StyledText.ListElement>Follow the instructions to choose an account</StyledText.ListElement>
                <StyledText.ListElement>Register (see image) by completing the final steps.</StyledText.ListElement>
                <StyledText.ListElement>Then click &quot;Agree & Create Account&quot;</StyledText.ListElement>
                <StyledText.ListElement>To finish creating your account, you need to confirm your email.</StyledText.ListElement>
              </StyledText.List>
              <StyledText.Image lazy={true} webpSrc={googleGithubWebp} pngSrc={googleGithub} alt="Social register" />
              <StyledText.Image lazy={true} webpSrc={finalStepsWebp} pngSrc={finalSteps} alt="Social register final steps" />
            </StyledText.Paragraph>
            <StyledText.Paragraph>
              Troubleshooting if you&apos;re having a problem logging in:
              <StyledText.List>
                <StyledText.ListElement>
                  If you&apos;re having trouble with your password, learn how to{' '}
                  <StyledText.InlineLink href="#reset-password">reset your password</StyledText.InlineLink>.{' '}
                </StyledText.ListElement>
                <StyledText.ListElement>
                  If you still can&apos;t log in please reach out using our&nbsp;
                  <StyledText.InlineLink target="_blank" href={Paths.contact} rel="noopener noreferrer">
                    contact us form
                  </StyledText.InlineLink>
                </StyledText.ListElement>
              </StyledText.List>
            </StyledText.Paragraph>
            <StyledText.Header id="reset-password">{++counter}. How do I reset a forgotten password?</StyledText.Header>
            <StyledText.Paragraph>
              If you&apos;re not logged in to Unbounded: <br />
              <StyledText.List>
                <StyledText.ListElement>
                  Go to{' '}
                  <StyledText.InlineLink target="_blank" href="https://id.unbounded.network/" rel="noopener noreferrer">
                    https://id.unbounded.network/
                  </StyledText.InlineLink>
                </StyledText.ListElement>
                <StyledText.ListElement>Click &quot;Forgot password?&quot;.</StyledText.ListElement>
              </StyledText.List>
              Follow the Password Recovery instructions.
            </StyledText.Paragraph>
            <Styled.CantFindAnswer>
              Can&apos;t find the answer you&apos;re looking for? Reach out to us using our&nbsp;
              <StyledText.InlineLink target="_blank" href={Paths.contact} rel="noopener noreferrer">
                contact us form
              </StyledText.InlineLink>
            </Styled.CantFindAnswer>
          </StyledText.Text>
        </StyledText.RowContainer>
      </Layout.Content>
    </Layout>
  )
}

export default FAQPage
